import React from 'react';

const More = () => {
    return (
        <div className="container-fluid">
        <h3 className="text-center mt-4 mb-2">Más</h3>

        

        <div class="card-columns mt-4">
  <div class="card bg-primary shadow2 rounded">
    <div class="card-body text-center">
    <img src="/pesos-card2.png" className="m-2" width="42px" height="42px"/>
    <p className="card-text text-white m-0 p-0">Perfil</p>
    </div>
  </div>
  <div class="card bg-primary shadow2 rounded">
    <div class="card-body text-center">
    <img src="/logros.png" className="m-2" width="42px" height="42px"/>
    <p className="card-text text-white m-0 p-0">Logros</p>
    </div>
  </div>
  <div class="card bg-primary shadow2 rounded">
    <div class="card-body text-center">
    <img src="/banco.png" className="m-2" width="42px" height="42px"/>
     <p className="card-text text-white m-0 p-0">Banco</p>
    </div>
  </div>
  <div class="card bg-primary shadow2 rounded">
    <div class="card-body text-center">
    <img src="/tiendas.png" className="m-2" width="42px" height="42px"/>
   <p className="card-text text-white m-0 p-0">Tiendas</p>
    </div>
  </div>
  <div class="card bg-primary shadow2 rounded">
    <div class="card-body text-center">
    <img src="/regalos.png" className="m-2" width="42px" height="42px"/>
   <p className="card-text text-white m-0 p-0">Regalos</p>
    </div>
  </div>
  <div class="card bg-primary shadow2 rounded">
    <div class="card-body text-center">
    <img src="/etiqueta.png" className="m-2" width="42px" height="42px"/>
  <p className="card-text text-white m-0 p-0">E-Commerce</p>
    </div>
  </div>

  <div class="card bg-primary shadow2 rounded">
    <div class="card-body text-center">
    <img src="/ayuda.png" className="m-2" width="42px" height="42px"/>
    <p className="card-text text-white m-0 p-0">Ayuda</p>
    </div>
  </div>

  <div class="card bg-primary shadow2 rounded">
    <div class="card-body text-center">
    <img src="/ecommerce.png" className="m-2" width="42px" height="42px"/>
  <p className="card-text text-white m-0 p-0">Comercio</p>
    </div>
  </div>

  <div class="card bg-primary shadow2 rounded">
    <div class="card-body text-center">
    <img src="/logout.png" className="m-2" width="42px" height="42px"/>
 <p className="card-text text-white m-0 p-0">Cerrar Sesión</p>
    </div>
  </div>
</div>

      <br />
        <br />
        <br />
        <br />
        <br />
        <br />
    </div>
    );
}
 
export default More;